import React from "react";

import { Link } from "react-router-dom";
import '../styles/Landing.css'

export const Landing = ({setResponse}) => {

  return (
    <>
    <div className="container">
        <div className="bubbles">
            <span style={{"--i":"11"}}></span>
            <span style={{"--i":"12"}}></span>
            <span style={{"--i":"24"}}></span>
            <span style={{"--i":"10"}}></span>
            <span style={{"--i":"14"}}></span>
            <span style={{"--i":"23"}}></span>
            <span style={{"--i":"18"}}></span>
            <span style={{"--i":"16"}}></span>
            <span style={{"--i":"19"}}></span>
            <span style={{"--i":"20"}}></span>
            <span style={{"--i":"22"}}></span>
            <span style={{"--i":"25"}}></span>
            <span style={{"--i":"18"}}></span>
            <span style={{"--i":"21"}}></span>
            <span style={{"--i":"15"}}></span>
            <span style={{"--i":"13"}}></span>
            <span style={{"--i":"26"}}></span>
            <span style={{"--i":"17"}}></span>
            <span style={{"--i":"13"}}></span>
            <span style={{"--i":"28"}}></span>
            <span style={{"--i":"11"}}></span>
            <span style={{"--i":"12"}}></span>
            <span style={{"--i":"24"}}></span>
            <span style={{"--i":"10"}}></span>
            <span style={{"--i":"14"}}></span>
            <span style={{"--i":"23"}}></span>
            <span style={{"--i":"18"}}></span>
            <span style={{"--i":"16"}}></span>
            <span style={{"--i":"19"}}></span>
            <span style={{"--i":"20"}}></span>
            <span style={{"--i":"22"}}></span>
            <span style={{"--i":"25"}}></span>
            <span style={{"--i":"18"}}></span>
            <span style={{"--i":"21"}}></span>
            <span style={{"--i":"15"}}></span>
            <span style={{"--i":"13"}}></span>
            <span style={{"--i":"26"}}></span>
            <span style={{"--i":"17"}}></span>
            <span style={{"--i":"13"}}></span>
            <span style={{"--i":"28"}}></span>
            <span style={{"--i":"11"}}></span>
            <span style={{"--i":"12"}}></span>
            <span style={{"--i":"24"}}></span>
            <span style={{"--i":"10"}}></span>
            <span style={{"--i":"14"}}></span>
            <span style={{"--i":"23"}}></span>
            <span style={{"--i":"18"}}></span>
            <span style={{"--i":"16"}}></span>
            <span style={{"--i":"19"}}></span>
            <span style={{"--i":"20"}}></span>
            <span style={{"--i":"22"}}></span>
            <span style={{"--i":"25"}}></span>
            <span style={{"--i":"18"}}></span>
            <span style={{"--i":"21"}}></span>
            <span style={{"--i":"15"}}></span>
            <span style={{"--i":"13"}}></span>
            <span style={{"--i":"26"}}></span>
            <span style={{"--i":"17"}}></span>
            <span style={{"--i":"13"}}></span>
            <span style={{"--i":"28"}}></span>
            <span style={{"--i":"11"}}></span>
            <span style={{"--i":"12"}}></span>
            <span style={{"--i":"24"}}></span>
            <span style={{"--i":"10"}}></span>
            <span style={{"--i":"14"}}></span>
            <span style={{"--i":"23"}}></span>
            <span style={{"--i":"18"}}></span>
            <span style={{"--i":"16"}}></span>
            <span style={{"--i":"19"}}></span>
            <span style={{"--i":"20"}}></span>
            <span style={{"--i":"22"}}></span>
            <span style={{"--i":"25"}}></span>
            <span style={{"--i":"18"}}></span>
            <span style={{"--i":"21"}}></span>
            <span style={{"--i":"15"}}></span>
            <span style={{"--i":"13"}}></span>
            <span style={{"--i":"26"}}></span>
            <span style={{"--i":"17"}}></span>
            <span style={{"--i":"13"}}></span>
            <span style={{"--i":"28"}}></span>
        </div>
        <div className="titleContainer">
          <div className="title">
              Content<div className="AI">AI</div>
          </div>
          <div>
              <Link className="Link" to={"/art"}>Create Art</Link>
              <Link className="Link" to={"/ads"}>Create Ads</Link>
          </div>
        </div>

    </div>
    </>
  );
}
